/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { ColorBrandBlue5, ColorNeutralDarkGrey, Spacing4 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';

export const ActiveCount = styled.div`
    padding: 2px;
    background-color: ${ColorBrandBlue5};
    border-radius: 2px;
    margin-left: ${Spacing4};
`;

export const HitCount = styled(Typography.Body)`
    color: ${ColorNeutralDarkGrey};
`;
